module.exports = __webpack_public_path__ + "static/logo-29d3bb5460b45c10653ff288f6c362de.png";